import { ethers } from 'ethers'
import { getChainContracts } from '../constants/contracts.js'
import { getChainData } from '@/constants/chains'
import { successToast } from '../helpers/toast.js'

import Bridge from '../constants/abis/Bridge.json'
import Store from '../store.js'
import WalletService from './wallet.js'

const txType = Object.freeze({
  MINT: 'mintToBridgeOut', // mint
  RELEASE: 'unlockToBridgeIn'
})

class ValidatorService {
  constructor () {
    this.networks = [ // ** number network use = id ** //
      // { name: 'Goerli', id: 5 },
      { name: 'Sepolia', id: 11155111 },
      { name: 'Holesky', id: 17000 },
      // { name: 'Mumbai - Testnet', id: 80001 },
      { name: 'Amoy - Testnet', id: 80002 },
      { name: 'BNB Smart Chain - Testnet', id: 97 },
      // { name: 'Arbitrum Goerli - Testnet', id: 421613 },
      { name: 'Arbitrum Sepolia - Testnet', id: 421614 },
      // { name: 'Optimism Goerli - Testnet', id: 420 },
      { name: 'Optimism Sepolia - Testnet', id: 11155420 },
      // { name: 'Base Goerli - Testnet', id: 84531 },
      { name: 'Base Sepolia - Testnet', id: 84532 },
      { name: 'Linea - Testnet', id: 59140 },
      { name: 'Avalanche Fuji - Testnet', id: 43113 },
      { name: 'Fantom - Testnet', id: 4002 },
      { name: 'Bitkub Chain - Testnet', id: 25925 },
      { name: 'Flare - Testnet Coston', id: 16 },
      { name: 'Public Goods Network - Testnet', id: 58008 },
      { name: 'Haqq Chain - Testnet', id: 54211 },
      { name: 'Lightlink - Testnet Pegasus', id: 1891 },
      { name: 'Taiko - Testnet Jolnir L2', id: 167007 },
      { name: 'Mode - Testnet', id: 919 },
      { name: 'Neo EVM - Testnet', id: 2970385 },
      { name: 'ZetaChain - Testnet Athens 3', id: 7001 },
      { name: 'Scroll - Testnet Sepolia', id: 534351 },
      { name: 'Mantle - Testnet', id: 5001 },
      { name: 'opBNB - Testnet', id: 5611 },
      { name: 'Omni Network - Testnet', id: 165 },
      { name: 'Manta Pacific - Testnet', id: 3441005 },
      { name: 'Kroma - Testnet Sepolia', id: 2358 },
      { name: 'Polygon zkEVM - Testnet', id: 1442 },
      { name: 'Shardeum Sphinx 1.X - Testnet Dapp', id: 8081 },
      { name: 'X1 (OKX L2) - Testnet', id: 195 },
      { name: 'Arbitrum Stylus - Testnet', id: 23011913 },
      { name: 'Frame - Testnet', id: 68840142 },
      { name: 'zKatana - Testnet', id: 1261120 },
      { name: 'Redstone - Testnet', id: 17001 },
      { name: 'Gnosis - Testnet Chiado', id: 10200 },
      { name: 'Zora Sepolia - Testnet', id: 999999999 },
      { name: 'Blast Sepolia - Testnet', id: 168587773 },
      { name: 'Taiko Katla - Testnet', id: 167008 },
      { name: 'Berachain Artio - Testnet', id: 80085 },
      { name: 'Tabichain 1.0 - Testnet', id: 9789 },
      { name: 'Taiko - Testnet Hekla L2', id: 167009 },
      { name: 'ALIENX Hal - Testnet', id: 10241025 },
      { name: 'Sei - Testnet', id: 1328 },
      { name: 'Soneium - Minato', id: 1946 },
      { name: 'Story - Testnet', id: 1513 },
      { name: 'Hemi - Sepolia', id: 743111 },
      { name: 'Kaia Kairos - Testnet', id: 1001 },
      { name: 'Unichain Sepolia - Testnet', id: 1301 },
      { name: 'Superposition - Testnet', id: 98985 },
      { name: 'Ink - Sepolia', id: 763373 },
      // { name: 'Mint - Testnet', id: 1686 },



      // { name: 'Orenium Testnet Protocol', id: 8890 },

      
      // { name: 'Metis - Testnet Goerli', id: 599 },
      // { name: 'Neon EVM - Testnet Devnet', id: 245022926 },

      

      // { name: 'zkSync ERA - Testnet', id: 280 },
       
    ];
    this.txSigner = new ethers.Wallet(process.env.VUE_APP_TRUSTED_SIGNER_PK);
  }

  getBridgeContract (chainId) {
    const bridgeAddress = getChainContracts(chainId).bridge
    const provider = new ethers.providers.JsonRpcProvider(getChainData(chainId).rpc_url)
    const bridge = new ethers.Contract(bridgeAddress, Bridge.abi, provider)

    return bridge
  }

  async prepareMintTx(targetChain, sourceChain, token, amountWei, receiver) {
    const tokenName = await WalletService.getTokenName(token);
    const tokenSymbol = await WalletService.getTokenSymbol(token);
    const wrappedTokenName = `Interface ${tokenName}`; //
    const wrappedTokenSymbol = `I${tokenSymbol}`; //
  
    const timestamp = Math.floor(Date.now() / 1000); // เวลาปัจจุบันในรูปแบบ UNIX timestamp (วินาที)
  
    const txHash = ethers.utils.solidityKeccak256(
      ['uint32', 'address', 'uint256', 'address', 'string', 'string', 'uint256'],
      [sourceChain, token, amountWei, receiver, wrappedTokenName, wrappedTokenSymbol, timestamp]
    );
  
    const txArr = ethers.utils.arrayify(txHash);
    const txSigned = await this.txSigner.signMessage(txArr);
  
    return {
      targetChain: targetChain,
      sourceChain: sourceChain,
      token: token,
      amountWei: amountWei,
      amount: ethers.utils.formatEther(amountWei),
      receiver: receiver,
      wrappedTokenName: wrappedTokenName,
      wrappedTokenSymbol: wrappedTokenSymbol,
      txHash: txHash,
      txSigned: txSigned,
      timestamp: timestamp, // เพิ่มค่า timestamp ลงในออบเจกต์
      type: txType.MINT
    };
  }

  async prepareReleaseTx (sourceChain, wrappedToken, amountWei, receiver) {
    const wTokens = Store.state.wrappedTokens
    let wToken
    for (let i = 0; i < wTokens.length; i++) {
      if (wrappedToken === wTokens[i].wrappedToken) {
        wToken = wTokens[i]
      }
    }

    const timestamp = Math.floor(Date.now() / 1000); // เวลาปัจจุบันในรูปแบบ UNIX timestamp (วินาที)

    const txHash = ethers.utils.solidityKeccak256(
      ['uint32', 'address', 'uint256', 'address', 'uint256'],
      [sourceChain, wToken.token, amountWei, receiver, timestamp]
    )
    const txArr = ethers.utils.arrayify(txHash)
    const txSigned = await this.txSigner.signMessage(txArr)

    return {
      targetChain: wToken.sourceChain,
      sourceChain: sourceChain,
      token: wToken.token,
      amountWei: amountWei,
      amount: ethers.utils.formatEther(amountWei),
      receiver: receiver,
      txHash: txHash,
      txSigned: txSigned,
      timestamp: timestamp, // เพิ่มค่า timestamp ลงในออบเจกต์
      type: txType.RELEASE
    }
  }

  async start() {
    for (const network of this.networks) {
      const bridge = this.getBridgeContract(network.id);

      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });

      bridge.on('Lock', async (targetChain, token, receiver, amountWei) => {
        const mintTx = await this.prepareMintTx(targetChain, network.id, token, amountWei, receiver);
        Store.commit('addClaim', mintTx);
      
        if (accounts.length > 0) {
          const userAccount = accounts[0];
          if (receiver.toLowerCase() === userAccount.toLowerCase()) {
            successToast(`You can claim now ${ethers.utils.formatEther(amountWei)} tokens`);
          }
        }
      });      

      bridge.on('Mint', (wrappedToken, amountWei, receiver) => {
        if (accounts.length > 0) {
          const userAccount = accounts[0];
          if (receiver.toLowerCase() === userAccount.toLowerCase()) {
            successToast(`Claimed ${ethers.utils.formatEther(amountWei)} tokens`);
          }
        }
      });
      
      bridge.on('Burn', async (wrappedToken, amountWei, receiver) => {
        if (accounts.length > 0) {
          const userAccount = accounts[0];
          if (receiver.toLowerCase() === userAccount.toLowerCase()) {
            const releaseTx = await this.prepareReleaseTx(network.id, wrappedToken, amountWei, receiver);
            Store.commit('addClaim', releaseTx);
            successToast(`You can claim now ${ethers.utils.formatEther(amountWei)} tokens`);
          }
        }
      });
      
      bridge.on('Release', (sourceChain, token, amountWei, receiver) => {
        if (accounts.length > 0) {
          const userAccount = accounts[0];
          if (receiver.toLowerCase() === userAccount.toLowerCase()) {
            successToast(`Claimed ${ethers.utils.formatEther(amountWei)} tokens`);
          }
        }
      });

      bridge.on('WrappedTokenDeployed', (sourceChain, nativeToken, wrappedToken, receiver) => {
        if (accounts.length > 0) {
          const userAccount = accounts[0];
          if (receiver.toLowerCase() === userAccount.toLowerCase()) {
            successToast(`New Interface token address: ${wrappedToken}`);
          }
        }
      });
    }
  }
}

export default ValidatorService
